import React from 'react'

import { EditBudget } from '~/modules/retailMedia/components/EditBudget'

/**
 * Componente isolado usado na listagem de anúncios para edição de custo
 */
const EditBudgetColumn: RowComponent = ({
  data,
  strategy,
  costType,
  isEdit,
  origin,
  initialCostOverride,
  onRequestEdit,
  onCancel
}) => {
  return (
    <EditBudget
      editType={costType}
      data={data}
      strategy={strategy}
      isEdit={isEdit}
      origin={origin}
      initialCostOverride={initialCostOverride}
      onRequestEdit={onRequestEdit}
      onCancel={onCancel}
    />
  )
}

export default EditBudgetColumn
